/**
 * @generated SignedSource<<2f0571cd644709f5f9453ebb78c54b54>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type InternPrivacyWebhooksEventsQuery$variables = {
  limit: number;
  offset: number;
  status?: string | null;
  topic?: string | null;
};
export type InternPrivacyWebhooksEventsQuery$data = {
  readonly internPrivacyWebhookEvents: {
    readonly events: ReadonlyArray<{
      readonly brandName: string | null;
      readonly completedAt: any | null;
      readonly createdAt: any;
      readonly customerEmailMasked: string | null;
      readonly errorMessage: string | null;
      readonly id: string;
      readonly shopDomain: string;
      readonly shopifyEventId: string;
      readonly status: string;
      readonly topic: string;
    }>;
    readonly hasNextPage: boolean;
    readonly hasPreviousPage: boolean;
    readonly totalCount: number;
  };
};
export type InternPrivacyWebhooksEventsQuery = {
  response: InternPrivacyWebhooksEventsQuery$data;
  variables: InternPrivacyWebhooksEventsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "limit"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "offset"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "status"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "topic"
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "limit",
        "variableName": "limit"
      },
      {
        "kind": "Variable",
        "name": "offset",
        "variableName": "offset"
      },
      {
        "kind": "Variable",
        "name": "status",
        "variableName": "status"
      },
      {
        "kind": "Variable",
        "name": "topic",
        "variableName": "topic"
      }
    ],
    "concreteType": "PrivacyWebhookEventsConnection",
    "kind": "LinkedField",
    "name": "internPrivacyWebhookEvents",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PrivacyWebhookEventType",
        "kind": "LinkedField",
        "name": "events",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "shopifyEventId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "topic",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "shopDomain",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "brandName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "customerEmailMasked",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "errorMessage",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "completedAt",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasNextPage",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasPreviousPage",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "InternPrivacyWebhooksEventsQuery",
    "selections": (v4/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "InternPrivacyWebhooksEventsQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "f6df4ae9d090852f8d83fffe0f2a5d1e",
    "id": null,
    "metadata": {},
    "name": "InternPrivacyWebhooksEventsQuery",
    "operationKind": "query",
    "text": "query InternPrivacyWebhooksEventsQuery(\n  $status: String\n  $topic: String\n  $limit: Int!\n  $offset: Int!\n) {\n  internPrivacyWebhookEvents(status: $status, topic: $topic, limit: $limit, offset: $offset) {\n    events {\n      id\n      shopifyEventId\n      topic\n      shopDomain\n      brandName\n      customerEmailMasked\n      status\n      errorMessage\n      createdAt\n      completedAt\n    }\n    totalCount\n    hasNextPage\n    hasPreviousPage\n  }\n}\n"
  }
};
})();

(node as any).hash = "46aef2f3c50aa091ae61b8fccb29f002";

export default node;
